module.exports = __webpack_public_path__ + "static/media/W5@1.5x.b1d1267f.png";